export const styles = {
  listWrap: {
    padding: '8px',
  },
};
